import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Bounce, ToastContainer} from "react-toastify";
import InvoiceChecker from "./InvoiceChecker";
import {LoadingBarContainer} from "react-top-loading-bar";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <>
        <InvoiceChecker />
        <LoadingBarContainer>
            <App />
        </LoadingBarContainer>
        <ToastContainer
            position="bottom-center"
            autoClose={2999}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick={false}
            rtl={true}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
            transition={Bounce}
            toastStyle={{
                fontFamily: "IranSANS, sans-serif",
            }}
        />
    </>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
